import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d0ff6fae"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "invoiceListPage" };
const _hoisted_2 = { class: "invoiceBox" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "invoiceTitle" };
const _hoisted_5 = { class: "invoiceNum" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "numText" }, "购买日期", -1));
const _hoisted_7 = { class: "invoiceTime" };
const _hoisted_8 = { class: "invoiceNum" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "numText" }, "开票日期", -1));
const _hoisted_10 = { class: "invoiceTime" };
const _hoisted_11 = { class: "invoiceBottom flex-align-center" };
const _hoisted_12 = { class: "invoicePrice" };
const _hoisted_13 = { class: "priceDeatil" };
const _hoisted_14 = { class: "invoiceTip" };
const _hoisted_15 = { class: "invoiceBtn" };
const _hoisted_16 = {
    key: 0,
    class: "viewDetail"
};
const _hoisted_17 = {
    key: 1,
    class: "greyBtn"
};
const _hoisted_18 = { class: "noMore" };
import { hostPath } from '@/public/utils/basePath';
import { invoiceList } from '@/api/invoice';
import Empty from '@/components/common/Empty.vue';
import { appPort, closeWebView, hiddenAppNavBar } from '@/widget/index';
import Header from '@/components/common/Header.vue';
import { ref, onMounted, getCurrentInstance } from 'vue';
import { Toast } from 'vant';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { proxy: { $showLoading, $hideLoading } } = getCurrentInstance();
        const isApp = ref(appPort());
        const myInvoiceList = ref([]);
        const pageCount = ref(1);
        const noMore = ref(true);
        var total = 0;
        var pageNo = 1;
        /* 返回 */
        const backFn = () => {
            if (isApp.value) {
                closeWebView();
            }
            else {
                history.go(-1);
            }
        };
        const getData = () => {
            $showLoading();
            invoiceList({
                page: pageNo
            }).then((res) => {
                $hideLoading();
                if (res.code === 200) {
                    pageCount.value = res.data.total;
                    pageCount.value = res.data.pages;
                    if (pageNo === 1) {
                        myInvoiceList.value = res.data.items;
                    }
                    else {
                        myInvoiceList.value = res.data.items.concat(res.data.items);
                    }
                    if (pageCount.value > pageNo) {
                        pageNo++;
                        noMore.value = false;
                    }
                    else {
                        noMore.value = true;
                    }
                }
            });
        };
        // 'INVOICING' : 开票中,'ISSUED':已开票,'REVERSED'：已冲销'
        const goDetailBtn = (invoiceId, status) => {
            if (status === 'INVOICING') {
                Toast('开票中，请耐心等待……');
            }
            else {
                location.href = `${hostPath}/learn/invoice/detail/${invoiceId}`;
            }
        };
        /* app里隐藏头部 */
        if (isApp.value) {
            hiddenAppNavBar();
        }
        onMounted(() => {
            getData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header, {
                    onBackFn: backFn,
                    showBack: true,
                    isColor: true,
                    pageTitle: '我的发票'
                }),
                _createElementVNode("ul", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myInvoiceList.value, (item, key) => {
                        return (_openBlock(), _createElementBlock("li", {
                            class: "invoiceList",
                            key: key,
                            onClick: _withModifiers(($event) => (goDetailBtn(item.invoiceId, item.invoiceStatus)), ["stop"])
                        }, [
                            _createElementVNode("p", _hoisted_4, "购买商品：" + _toDisplayString(item.productName), 1),
                            _createElementVNode("div", _hoisted_5, [
                                _hoisted_6,
                                _createElementVNode("span", _hoisted_7, _toDisplayString(item.orderCreateTime), 1)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _hoisted_9,
                                _createElementVNode("span", _hoisted_10, _toDisplayString(item.createdAt), 1)
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("span", _hoisted_13, "￥" + _toDisplayString(item.price), 1),
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(item.moduleName), 1)
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    (item.bnt1)
                                        ? (_openBlock(), _createElementBlock("button", _hoisted_16, _toDisplayString(item.bnt1), 1))
                                        : _createCommentVNode("", true),
                                    (item.bnt2)
                                        ? (_openBlock(), _createElementBlock("button", _hoisted_17, _toDisplayString(item.bnt2), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ], 8, _hoisted_3));
                    }), 128))
                ]),
                _withDirectives(_createVNode(Empty, { text: '暂无内容，探索一下其他内容吧~' }, null, 512), [
                    [_vShow, noMore.value && myInvoiceList.value.length === 0]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_18, "没有更多了", 512), [
                    [_vShow, noMore.value && pageCount.value === _unref(pageNo)]
                ])
            ]));
        };
    }
});
